export const isJest = () => {
  return process.env["JEST_WORKER_ID"] !== undefined;
};
